// TimeRangeChipList Component - Renders time range chips without anonymous functions
import { Chip } from '@mui/material';

interface TimeRangeChipListProps {
  ranges: readonly string[];
  selectedRange: string;
  onRangeClick: (range: string) => () => void;
}

interface TimeRangeChipProps {
  range: string;
  isSelected: boolean;
  onClick: () => void;
}

function TimeRangeChip({ range, isSelected, onClick }: TimeRangeChipProps) {
  return (
    <Chip
      label={range}
      size="small"
      variant={isSelected ? 'filled' : 'outlined'}
      color={isSelected ? 'primary' : 'default'}
      onClick={onClick}
      sx={{ cursor: 'pointer' }}
    />
  );
}

export function TimeRangeChipList({ ranges, selectedRange, onRangeClick }: TimeRangeChipListProps) {
  function transformRange(range: string) {
    return {
      range,
      isSelected: selectedRange === range,
      onClick: onRangeClick(range),
    };
  }

  const items = ranges.map(transformRange);

  function renderItem({
    range,
    isSelected,
    onClick,
  }: {
    range: string;
    isSelected: boolean;
    onClick: () => void;
  }) {
    return <TimeRangeChip key={range} range={range} isSelected={isSelected} onClick={onClick} />;
  }

  const renderItems = items.map(renderItem);

  return <>{renderItems}</>;
}

export default TimeRangeChipList;
